import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components/macro';

import { Box, Flex } from 'web-ui-kit/containers';
import { blue, primaryM } from 'web-ui-kit/colors';
import { H2, H3, H4, H5 } from 'web-ui-kit/heading';
import Modal from 'web-ui-kit/modals/FormModal';
import { BodyLargeStyles, Header2LargeStyles } from 'web-ui-kit/typography';
import SecondaryButton from 'web-ui-kit/buttons/SecondaryButton';

export const PRE_SWAP_MODAL_ID = 'pre-swap-modal';

export default function PreSwapModal (props) {
  return ReactDOM.createPortal(
    <PreSwapModalContent {...props} />,
    document.body
  );
}

export const PreSwapModalContent = ({ onToggleModal, onSwapClick }) => (
  <Modal
    id={PRE_SWAP_MODAL_ID}
    dispatch={(event) => {
      const { type } = event;

      if (type === `${PRE_SWAP_MODAL_ID}-modal-close-request`) {
        onToggleModal();
      }
    }}
  >
    <ModalTitle center>
      Are you sure?
    </ModalTitle>

    <Paragraph>
      Looks like this piece is too big for the space! Are you sure you want to make the swap?
    </Paragraph>
    <div style={{ display: 'flex', height: '3rem' }}>
      <SecondaryButton
        id={'confirm-large-swap'}
        labelText={'Yes, let’s swap'}
        fluid
        dispatch={(event) => {
          const { type } = event;

          if (type === 'confirm-large-swap-button-clicked') {
            onSwapClick();
          }
        }}
      />
    </div>

    <SecondaryParagraphFlex onClick={onToggleModal}>
      <SecondaryParagraph>
        No, let’s find a different option
      </SecondaryParagraph>
    </SecondaryParagraphFlex>
  </Modal>
);

/** Styles */
const CloseBox = styled(Box)`
  cursor: pointer;
  position: absolute;
  right: 24px;
  top: 24px;
`;
CloseBox.displayName = 'CloseBox';

const ModalTitle = styled(H2)`
  margin: 40px 0;
  text-align: center;
  width: 100%;

  ${Header2LargeStyles};
`;
ModalTitle.displayName = 'ModalTitle';

const Paragraph = styled(H4)`
  font-weight: 300;
  margin-bottom: 32px;
  max-width: 504px;
  text-align: center;
  white-space: pre-wrap;

  ${BodyLargeStyles};
  margin: 1rem 0;
`;
Paragraph.displayName = 'Paragraph';

const SecondaryParagraphFlex = styled(Flex)`
  cursor: pointer;
  margin-top: 1.25rem;
  width: 100%;
`;
SecondaryParagraphFlex.displayName = 'SecondaryParagraphFlex';

const SecondaryParagraph = styled(H5)`
    color: ${blue};
    letter-spacing: 1px;
    font-weight: 500;
    text-align: center;

    ${BodyLargeStyles};
    font-size: 1rem;
    width: 100%;
    text-align: center;
    color: ${primaryM};
    letter-spacing: normal;
`;
SecondaryParagraph.displayName = 'SecondaryParagraph';

const CtaFlex = styled(Flex)`
  height: 48px;
  width: 264px;
`;
CtaFlex.displayName = 'CtaFlex';

const CtaContent = styled(H3)`
  line-height: 25px;
`;
CtaContent.displayName = 'CtaContent';
